import { useLocation, Link } from 'react-router-dom';
import '@/styles/PublicNav.css';

export default function PublicNav() {
  const location = useLocation();
  const path = location.pathname;

  const isCultActive = path.startsWith('/gallery/cult');
  const isFramedActive = path.startsWith('/gallery/framed');
  const isTravelsActive = path.startsWith('/travels') || path.startsWith('/trip');
  const isLabsActive = path.startsWith('/gallery/labs');
  const isAuthenticated = !!localStorage.getItem('werner_token');

  return (
    <nav className="wl-nav">
      <Link className="wl-nav-logo" to="/gallery">
        <img src="/logo-192.png" alt="W" style={{ clipPath: 'url(#squircle)' }} />
        <span className="wl-nav-logo-text">ERNERLABS</span>
      </Link>
      <div className="wl-nav-links">
        <Link className={`wl-nav-link ${isCultActive ? 'active' : ''}`} to="/gallery/cult">
          <span className="wl-nav-name">Cult of One</span>
        </Link>
        <Link className={`wl-nav-link ${isFramedActive ? 'active' : ''}`} to="/gallery/framed">
          <span className="wl-nav-name">Framed</span>
        </Link>
        <Link className={`wl-nav-link ${isTravelsActive ? 'active' : ''}`} to="/travels">
          <span className="wl-nav-name">Journeys</span>
        </Link>
        <Link className={`wl-nav-link ${isLabsActive ? 'active' : ''}`} to="/gallery/labs">
          <span className="wl-nav-name">Labs</span>
        </Link>
        {isAuthenticated && (
          <Link className="wl-nav-link" to="/dashboard" title="Back to Zephyr OS">
            <span className="wl-nav-name">Zephyr OS</span>
          </Link>
        )}
      </div>
    </nav>
  );
}
